import { render, staticRenderFns } from "./TheMainCard.vue?vue&type=template&id=fcb2d50c&scoped=true&"
import script from "./TheMainCard.vue?vue&type=script&lang=ts&"
export * from "./TheMainCard.vue?vue&type=script&lang=ts&"
import style0 from "./TheMainCard.vue?vue&type=style&index=0&id=fcb2d50c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb2d50c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
